import { useMemo } from 'react';
import { useLocale } from '@adsk/alloy-react-helpers';

export const MEMBER_STATUSES = {
  ACTIVE: 'active',
  PENDING: 'pending',
};

export default () => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const options = useMemo(
    () => [
      {
        name: T.translate('ACTIVE'),
        id: MEMBER_STATUSES.ACTIVE,
      },
      {
        name: T.translate('INVITED'),
        id: MEMBER_STATUSES.PENDING,
      },
    ],
    [T]
  );

  const optionsMapById = useMemo(
    () =>
      options.reduce((map, status) => ({ ...map, [status.id]: status }), {}),
    [options]
  );

  return { options, optionsMapById };
};
